import React from 'react'
import { DrawerContent, DrawerRoot } from '@frontend/pole-ui/lib/components/Drawer'
import { Android } from '@/components/composed/pwa/Notification/components/Android/Android'
import { Ios } from '@/components/composed/pwa/Notification/components/Ios/Ios'
import { Header } from '../Header/Header'
import type { IComponentProps } from '../types'

export const BottomSheet = (props: IComponentProps) => {
  const { onClose, isOpen, onInstallApp, isIos } = props

  return (
    <DrawerRoot open={isOpen} onClose={onClose}>
      <DrawerContent title={<Header isPoleLogo={isIos} />} className={'notification'}>
        {isIos ? <Ios onActionButtonClick={onClose} /> : <Android onActionButtonClick={onInstallApp} />}
      </DrawerContent>
    </DrawerRoot>
  )
}
